import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from './Constants';
import RequestHelper from './RequestHelper';
import Utils from '../utils';
import { EVENT_TYPES } from '../lib/analytics/constants';
import Logger from '../lib/analytics/logger';
export default {
  /**
   * Helper method to get lobby items (live panels)
   */
  getLobbyItems: function () {
    var _getLobbyItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var callResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_LOBBY_ITEMS
              }, true);

            case 3:
              callResponse = _context.sent;
              return _context.abrupt("return", callResponse);

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              throw _context.t0;

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    function getLobbyItems() {
      return _getLobbyItems.apply(this, arguments);
    }

    return getLobbyItems;
  }(),

  /**
   * Helper method to add favourite game (live panels)
   */
  addFavouriteGame: function () {
    var _addFavouriteGame = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(itemId) {
      var response, eventPayload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.ADD_FAVOURITE,
                body: {
                  game_id: itemId
                },
                logJSON: true
              });

            case 3:
              response = _context2.sent;

              if (!(response[0].success === false)) {
                _context2.next = 8;
                break;
              }

              eventPayload = {
                description: "Failed to add favorite for ".concat(itemId, ", ").concat(response.error),
                code: 30
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              throw response.error;

            case 8:
              return _context2.abrupt("return", response['0']);

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              throw _context2.t0;

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 11]]);
    }));

    function addFavouriteGame(_x) {
      return _addFavouriteGame.apply(this, arguments);
    }

    return addFavouriteGame;
  }(),

  /**
   * Helper method to remove favourite game (live panels)
   */
  removeFavouriteGame: function () {
    var _removeFavouriteGame = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(itemId) {
      var response, eventPayload;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.REMOVE_FAVOURITE,
                body: {
                  game_id: itemId
                },
                logJSON: true
              });

            case 3:
              response = _context3.sent;

              if (!(response[0].success === false)) {
                _context3.next = 8;
                break;
              }

              eventPayload = {
                description: "Failed to remove favorite for ".concat(itemId, ", ").concat(response.error),
                code: 30
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              throw response.error;

            case 8:
              return _context3.abrupt("return", response['0']);

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);
              throw _context3.t0;

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 11]]);
    }));

    function removeFavouriteGame(_x2) {
      return _removeFavouriteGame.apply(this, arguments);
    }

    return removeFavouriteGame;
  }()
};